import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { CookieConsent } from "./CookieConsent";

export const Layout = () => (
  <div className="flex flex-col min-h-screen bg-[#FCFCFD]">
    <Navbar />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <CookieConsent />
  </div>
);
